import {
    useEffect,
    useState,
    type FC
} from "react";
import {
    View
} from "react-native";
import type ITabsOverflowMenuProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import type {
    TabsTriggerItem
} from "../../type";
import {
    Ellipsis as EllipsisIcon
} from "lucide-react-native";
import {
    getTabsOverflowTitle
} from "../../util";
import DropdownMenu from "../../../dropdownMenu";
import Button from "../../../button";

const TabsOverflowMenu: FC<ITabsOverflowMenuProps> = ({
    customLocalize,
    customTheme,
    isDisabled,
    isVisible,
    onLayout,
    onSelect,
    items,
    size,
    gap
}) => {
    const {
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        activeLocale,
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const [
        isOpen,
        setIsOpen
    ] = useState<boolean>(false);

    const {
        container: containerDynamicStyle
    } = useStyles({
        gap
    });

    const title = localize("tab-bar-more");

    const handleNoop = () => {};

    useEffect(() => {
        if(isVisible) {
            return;
        }

        setIsOpen(false);
    }, [
        isVisible
    ]);

    const renderIcon: NCoreUIKitIcon = (iconProps) => {
        return <EllipsisIcon
            color={iconProps.customColor ?? colors.content.icon[iconProps.color]}
            size={iconProps.size}
        />;
    };

    const renderItem = (item: TabsTriggerItem) => {
        return <DropdownMenu.Item
            onPress={() => onSelect(item.value)}
            title={getTabsOverflowTitle({
                locale: activeLocale,
                item
            })}
            isDisabled={item.isDisabled}
            icon={item.icon}
            key={item.value}
        />;
    };

    return <View
        style={[
            stylesheet.container,
            containerDynamicStyle,
            isVisible ? undefined : stylesheet.hidden
        ]}
        aria-hidden={isVisible ? undefined : true}
        onLayout={onLayout}
    >
        <DropdownMenu
            customLocalize={customLocalize}
            isOpen={isOpen && isVisible}
            customTheme={customTheme}
            onOpenChange={setIsOpen}
            title={title}
            align="end"
        >
            <DropdownMenu.Trigger>
                <Button
                    accessibilityLabel={title}
                    customTheme={customTheme}
                    isDisabled={isDisabled}
                    spreadBehaviour="free"
                    onPress={handleNoop}
                    icon={renderIcon}
                    variant="ghost"
                    type="neutral"
                    size={size}
                />
            </DropdownMenu.Trigger>
            <DropdownMenu.Content>
                {items.map(renderItem)}
            </DropdownMenu.Content>
        </DropdownMenu>
    </View>;
};
export default TabsOverflowMenu;
